import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_ERROR_MESSAGE } from '~/constants/config/common';
import { FuelContext } from '~/providers/FuelProvider';
import { setServiceabilityResults } from '~/redux/actions/address';
import { setPageLoading } from '~/redux/actions/common';
import { setNotifications } from '~/redux/actions/global';
import { ServiceabilityRequest, ServiceabilityResponse } from '~/types/address';
import { ReduxState } from '~/types/redux';
import useFetch from './useFetch';

interface ReturnType {
  runServiceability: (payload: ServiceabilityRequest) => Promise<ServiceabilityResponse>;
  data: ServiceabilityResponse | null;
  loading: boolean;
}

export const useRunServiceability = (): ReturnType => {
  const dispatch = useDispatch();
  const { router } = useContext(FuelContext);
  const { monarch } = useSelector((store: ReduxState) => store);

  const { data, loading, fetch } = useFetch<ServiceabilityResponse>(`v3/serviceability`, {
    method: 'post',
  });

  const runServiceability = async (payload: ServiceabilityRequest) => {
    try {
      payload.showPendingOrder = Boolean(monarch?.showPendingOrder);

      const serviceabilityResult = await fetch({
        body: JSON.stringify(payload),
      });

      if (serviceabilityResult) {
        dispatch(
          setServiceabilityResults({
            response: serviceabilityResult,
            router,
          })
        );
      }

      return serviceabilityResult;
    } catch (error) {
      dispatch(setPageLoading(false));
      dispatch(setNotifications([{ type: 'error', message: DEFAULT_ERROR_MESSAGE }]));
      return { success: false, error: DEFAULT_ERROR_MESSAGE };
    }
  };

  return { runServiceability, data, loading };
};
